<template>
	<el-main class="cart-page">
		<!-- Header -->
		<div class="cart-header">
			<div class="cart-header-left">
				<div class="cart-header-icon">
					<i class="el-icon-shopping-cart-2"></i>
				</div>
				<div class="cart-header-text">
					<h2>
						我的购物车
						<!-- <span class="cart-count-num" v-if="cartList.length > 0">（{{ cartList.length }}）</span> -->
					</h2>
					<p v-if="cartNum > 0">共 {{ cartNum }} 件商品</p>
				</div>
			</div>
			<div class="cart-header-right">
				<el-autocomplete
					popper-class="my-autocomplete-popper"
					class="cart-search-input"
					:class="{ 'is-expanded': searchQuery }"
					v-model="searchQuery"
					:fetch-suggestions="querySearch"
					placeholder="快捷搜索标准商品，添加至购物车..."
					clearable
					:trigger-on-focus="false"
					@select="handleSearchSelect"
					@keyup.enter.native="handleSearchEnter"
				>
					<i slot="prefix" class="el-input__icon el-icon-search"></i>
					<template slot-scope="{ item }">
						<div class="sku-item">
							<div class="sku-left">
								<el-tag size="mini" :type="item.isDigit == 1 ? 'success' : 'primary'" effect="plain" class="product-type-tag">{{ item.isDigit == 1 ? '电子版' : '纸质版' }}</el-tag>
								<div class="sku-name" v-html="highlightText(item.skuName)" :title="item.skuName"></div>
								<div class="sku-price">
									<span class="now-price">¥{{ item.vipPrice || item.curPrice || 0 }}</span>
									<span class="before-price" v-if="item.fixedPrice && item.fixedPrice > (item.vipPrice || item.curPrice)">¥{{ item.fixedPrice }}</span>
									<el-tag v-if="calcSkuDiscount(item) !== null" size="mini" type="danger" class="discount-tag">{{ calcSkuDiscount(item) }}折</el-tag>
									<span class="vip-price" v-if="!isVipUser && item.vipPrice && item.curPrice && item.vipPrice < item.curPrice">VIP ¥{{ item.vipPrice }}</span>
								</div>
							</div>
							<el-button type="primary" size="small" icon="el-icon-shopping-cart-2" class="sku-add-btn" @click.stop="handleSkuAddCart(item)">加入购物车</el-button>
						</div>
					</template>
				</el-autocomplete>
			</div>
		</div>

		<!-- 有商品 -->
		<template>
			<!-- 操作栏 -->
			<div class="cart-toolbar">
				<div class="cart-toolbar-left" :style="{ visibility: cartList.length > 0 ? 'visible' : 'hidden' }">
					<el-checkbox v-model="isCheckedAll" :disabled="cartList.length == 0" @change="selectAll">全选</el-checkbox>
					<el-select v-model="operatorFilter" v-if="cinfo.isMain || (!cinfo.isMain && cinfo.isBuy && uniqueOperators.length > 0)" placeholder="筛选添加人" clearable size="small" class="cart-operator-filter">
						<el-option v-for="op in uniqueOperators" :key="op" :label="op" :value="op"></el-option>
					</el-select>
				</div>
				<div class="cart-toolbar-right">
					<!-- v-if="cinfo.isMain || (!cinfo.isMain && cinfo.isBuy)" -->
					<el-button type="text" icon="el-icon-delete" @click="handleDetSelected" :style="{ visibility: cartList.length > 0 ? 'visible' : 'hidden' }">删除选中</el-button>
					<el-button type="text" icon="el-icon-delete-solid" @click="handleDetAll" :style="{ visibility: cartList.length > 0 ? 'visible' : 'hidden' }">清空购物车</el-button>
					<el-button type="primary" size="small" round icon="el-icon-plus" @click="handleApplyExtra">申请购买额外书单</el-button>
				</div>
			</div>

			<!-- 商品列表 -->
			<div v-loading="loading" class="cart-body" v-if="cartList.length > 0">
				<div v-for="(ginfo, gidx) in displayCartList" :key="'goodsbox_' + gidx" class="cart-item">
					<div class="cart-item-check">
						<el-checkbox v-model="ginfo.checked" name="rids[]"></el-checkbox>
					</div>

					<div class="cart-item-info">
						<!-- 自定义图书 -->
						<template v-if="ginfo.source === 'custom'">
							<h4 class="cart-item-title">
								<el-tag size="mini" type="info" effect="plain">额外书单</el-tag>
								{{ ginfo.prdSpuName }}
							</h4>
						</template>
						<!-- 标准库图书 -->
						<template v-else>
							<h4 class="cart-item-title">
								<span style="font-size: 14px;font-weight: 700;" :class="ginfo.isDigit == 0 ? 'colorblue' : ginfo.isDigit == 1 ? 'colorgreen' : ginfo.isDigit == 2 ? 'colorred' : 'colororange'"
									>【{{ ginfo.isDigit == 0 ? '纸质版' : ginfo.isDigit == 1 ? '电子版' + (ginfo.hadBuy ? ' · 已购' : '') : ginfo.isDigit == 2 ? '结构化版' : '额外添加' }}】</span
								>
							</h4>
							<div class="cart-item-spu">
								<a :class="{ 'cart-item-standard': ginfo.isDigit !== null }" @click="toStandardDet(ginfo)">{{ formatProductName(ginfo) }}</a>
								<span class="cart-item-type-badge" v-if="getStandardTypeName(ginfo.standardTypeId)">{{ getStandardTypeName(ginfo.standardTypeId) }}</span>
							</div>
						</template>
					</div>

					<!-- 标准库价格 -->
					<div class="cart-item-price" v-if="ginfo.isDigit !== null">
						<span class="cart-now-price">¥{{ getDisplayPrice(ginfo) }}</span>
						<span class="cart-before-price" v-if="ginfo.fixedPrice > getDisplayPrice(ginfo)">¥{{ ginfo.fixedPrice }}</span>
						<el-tag v-if="calculateDiscount(ginfo) !== null" size="mini" type="danger" class="cart-discount-tag">{{ (calculateDiscount(ginfo) * 10).toFixed(1) }}折</el-tag>
						<div class="cart-vip-price" v-if="!isVipUser && ginfo.vipPrice > 0">VIP ¥{{ ginfo.vipPrice }}</div>
					</div>

					<!-- 自定义图书价格 -->
					<div class="cart-item-price cart-item-price-custom" v-else>
						<span class="cart-price-na pending-price">待定价</span>
					</div>

					<div class="cart-item-qty">
						<span class="qty-label" v-if="ginfo.isDigit == 1" style="width: 94px; display: inline-block; padding-left: 46px">1</span>
						<el-input-number v-else v-model="ginfo.buyNum" :max="100" :min="1" size="small" controls-position="right"></el-input-number>
					</div>

					<div class="cart-item-subtotal" :style="'visibility: ' + (ginfo.isDigit === null ? 'hidden' : 'visible')">
						<span class="subtotal-label">小计</span>
						<span class="subtotal-value">¥{{ (getDisplayPrice(ginfo) * ginfo.buyNum).toFixed(2) }}</span>
					</div>

					<!-- <div class="cart-item-bought" :style="{'visibility': ginfo.hadBuy ? 'visible' : 'hidden'}">
						<span class="subtotal-label">是否已购</span>
						<i class="el-icon-check bought-yes"></i>
					</div> -->

					<div class="cart-item-operator">
						<span class="subtotal-label">添加人</span>
						<div class="operator-tags">
							<span v-for="(op, oidx) in getOperators(ginfo.remark)" :key="'op_' + oidx" class="operator-tag">{{ op }}</span>
						</div>
					</div>

					<div class="cart-item-actions">
						<el-link type="danger" :underline="false" icon="el-icon-delete" @click="handleDetItem(ginfo)"></el-link>
					</div>
				</div>
			</div>

			<!-- 底部结算栏 -->
			<div class="cart-bottom" v-if="cartList.length > 0">
				<div class="cart-bottom-left">
					<el-checkbox v-model="isCheckedAll" :disabled="cartList.length == 0" @change="selectAll">全选</el-checkbox>
					<span class="cart-bottom-count"
						>已选 <strong>{{ checkedNum }}</strong> 件</span
					>
				</div>

				<div class="cart-bottom-right">
					<div class="cart-bottom-prices">
						<div class="cart-bottom-total">
							<span class="total-label">合计</span>
							<span class="total-value">¥{{ total.toFixed(2) }}</span>
						</div>
						<div class="cart-bottom-ori">
							<span class="ori-label">原价</span>
							<span class="ori-value">¥{{ oriTotal.toFixed(2) }}</span>
						</div>
						<!-- <div class="cart-bottom-vip">
							<span class="vip-label">VIP价</span>
							<span class="vip-value">¥{{ vipTotal.toFixed(2) }}</span>
						</div> -->
					</div>

					<button v-if="cinfo.isMain || (!cinfo.isMain && cinfo.isBuy)" class="cart-settle-btn" :disabled="checkedNum === 0" :loading="loading" type="button" @click="toConfirm" v-click-once="2000">
						{{ loading ? '结算中...' : '去结算 (' + checkedNum + ')' }}
					</button>
				</div>
			</div>
		</template>

		<!-- 空购物车 -->
		<div v-if="cartList.length == 0" class="cart-empty">
			<div class="cart-empty-icon">
				<i class="el-icon-shopping-cart-2"></i>
			</div>
			<h3>购物车是空的</h3>
			<p>快去挑选您需要的标准与图书吧</p>
			<el-button round type="primary" size="medium" @click="goto({ path: '/StandardsList' })"> 去逛逛 <i class="el-icon-right el-icon--right"></i> </el-button>
		</div>

		<!-- 申请购买额外书单弹窗 -->
		<dialog-apply-extra ref="dialogApplyExtraRef" @confirm="onCustomConfirm" />
	</el-main>
</template>

<script>
	import Y from '@/utils/Y';
	import { mapState, mapGetters, mapActions } from 'vuex';
	import TMessageBox from '@/utils/TMessageBox';
	import TMessage from '@/utils/TMessage';
	import DialogApplyExtra from './components/DialogApplyExtra.vue';
	import { getSearchList } from '@/api/standards/search';
	import { getQueryProductInfo } from '@/api/standards/es';

	export default {
		data() {
			return {
				loading: false,
				isCheckedAll: false,
				searchQuery: '',
				operatorFilter: '',
				isVipUser: true,
			};
		},
		components: { DialogApplyExtra },
		computed: {
			...mapState('Cart', ['cartList']),
			...mapGetters('User', ['cinfo', 'uisLogin']),
			...mapGetters('Cart', ['checkedNum', 'cartNum', 'total', 'oriTotal', 'vipTotal', 'getDisplayPrice', 'calculateDiscount', 'getStandardTypeName']),
			uniqueOperators() {
				const ops = new Set();
				this.cartList.forEach(item => {
					this.getOperators(item.remark).forEach(op => ops.add(op));
				});
				return [...ops];
			},
			filteredCartList() {
				if (!this.operatorFilter) return this.cartList;
				return this.cartList.filter(item => {
					const operators = this.getOperators(item.remark);
					return operators.includes(this.operatorFilter);
				});
			},
			displayCartList() {
				return this.filteredCartList.slice(0, 200);
			}
		},
		mounted() {
			this.fetchStandardType();
		},
		methods: {
			...mapActions('Cart', ['checkAll', 'addCart', 'fetchStandardType']),
			...mapActions('Settings', ['setLoginShow']),

			// 格式化产品名称：如果 spuName 已包含 standardCode，则不重复拼接
			formatProductName(item) {
				if(item.isDigit == 0 && !item.skuId) {
					return item.spuName;
				}
				if (item.spuName && item.standardCode && item.spuName.indexOf(item.standardCode) !== -1) {
					return item.spuName;
				}
				return item.standardCode? item.standardCode + ' ' + item.spuName : item.spuName;
			},

			toStandardDet(ginfo) {
				if (ginfo.isDigit === null) return;
				const { standardId, skuName } = ginfo;
				const targetRoute = this.$router.resolve({
					path: '/StandardsDet',
					query: { id: standardId}
				});
				window.open(targetRoute.href, '_blank');
				// this.$router.push({ path: '/index/StandardsDet', query: { id: ginfo.standardId, standardName: ginfo.skuName, standardCode: ginfo.standardId } });
			},

			handleApplyExtra() {
				this.$refs.dialogApplyExtraRef.open();
			},

			onCustomConfirm(items) {
				const currentList = this.$store.state.Cart.cartList || [];
				this.$store.commit('Cart/SET_CART_LIST', [...items, ...currentList]);
			},

			async querySearch(queryString, cb) {
				if (!queryString.trim()) {
					cb([]);
					return;
				}
				try {
					const res = await getQueryProductInfo(queryString.trim());
					if (res.code == 200) {
						const results = res.data;
						cb(results);
					}
				} catch (e) {
					cb([]);
				}
			},

			handleSearchSelect(item) {
				return;
				const { id, standardName, standardCode } = item;
				const targetRoute = this.$router.resolve({
					path: '/index/StandardsDet',
					query: { id, standardName, standardCode }
				});
				window.open(targetRoute.href, '_blank');
			},

			handleSearchEnter() {
				return;
				if (this.searchQuery.trim()) {
					this.$router.push({ path: '/index/StandardsList', query: { keyword: this.searchQuery.trim() } });
				}
			},

			goto(route) {
				this.$router.push(route);
			},

			toConfirm() {
				if (this.checkedNum == 0) {
					Y.msg.warning('请选择结算的商品！');
					return false;
				}
				let params = { corporateCartDetailList: [] };
				this.cartList.forEach(item => {
					params.corporateCartDetailList.push({
						spuName: item.spuName,
						skuId: item.skuId,
						buyNum: item.buyNum,
						isSelected: item.checked ? 1 : 0
					});
				});
				this.loading = true;
				setTimeout(() => {
					this.postConsumerOrderUpdateCart(params);
				}, 300);
			},

			postConsumerOrderUpdateCart(params) {
				this.$store.dispatch('Cart/modifyCart', params).then(() => {
					this.$router.push({ path: '/Settle' });
					this.loading = false;
				});
			},

			handleDetItem(item) {
				TMessageBox.confirm('确定删除此商品吗？')
					.then(() => {
						let params = { corporateCartDetailList: [{ spuName: item.spuName, skuId: item.skuId, buyNum: item.buyNum }] };
						this.$store.dispatch('Cart/removeCart', params).then(() => Y.msg.success('已删除'));
					})
					.catch(() => {});
			},

			handleDetSelected() {
				if (this.checkedNum == 0) {
					Y.msg.warning('请选择要删除的商品！');
					return;
				}
				TMessageBox.confirm(`确定删除选中的${this.checkedNum}条记录吗?`)
					.then(() => {
						let params = { corporateCartDetailList: [] };
						this.cartList.forEach(item => {
							if (item.checked) params.corporateCartDetailList.push({ spuName: item.spuName, skuId: item.skuId, buyNum: item.buyNum });
						});
						this.$store.dispatch('Cart/removeCart', params).then(() => Y.msg.success(`已删除${this.checkedNum}条`));
					})
					.catch(() => {});
			},

			handleDetAll() {
				TMessageBox.confirm(`确定要清空购物车中所有商品吗?`)
					.then(() => {
						let params = { corporateCartDetailList: [] };
						this.cartList.forEach(item => params.corporateCartDetailList.push({ spuName: item.spuName, skuId: item.skuId, buyNum: item.buyNum }));
						this.$store.dispatch('Cart/removeCart', params).then(() => Y.msg.success('已清空'));
					})
					.catch(() => {});
			},

			getOperators(remark) {
				if (!remark) return [];
				return remark
					.split(/[,;，；]/)
					.map(s => s.trim())
					.filter(Boolean);
			},

			selectAll() {
				this.checkAll(this.isCheckedAll);
			},

			// 搜索建议项 - 计算折扣
			calcSkuDiscount(item) {
				const dp = item.vipPrice || item.curPrice || 0;
				const orig = item.fixedPrice;
				if (!dp || !orig || orig <= 0 || dp >= orig) return null;
				return ((dp / orig) * 10).toFixed(1);
			},

			// 搜索建议项 - 高亮匹配文本
			highlightText(text) {
				if (!text || !this.searchQuery) return text;
				const escapeRegExp = string => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
				const regex = new RegExp(escapeRegExp(this.searchQuery), 'gi');
				return text.replace(regex, match => `<span style="color: #ff4d4f; font-weight: bold;">${match}</span>`);
			},

			// 搜索建议项 - 加入购物车
			async handleSkuAddCart(item) {
				if (!this.uisLogin) {
					this.setLoginShow(true);
					return;
				}
				const skuId = item.prdSkuId || item.skuId;
				if (!skuId) {
					TMessage.warning('商品信息异常');
					return;
				}

				// 【电子版去重】电子版商品不支持重复购买，如购物车中已存在同 skuId，直接提示，不走动画/接口
				if (item.isDigit === 1) {
					const cartList = (this.$store.getters && this.$store.getters['Cart/cartList']) || [];
					const exists = cartList.some(c => c && (c.skuId === item.skuId || c.skuId === item.skuId));
					if (exists) {
						TMessage.warning('该电子版商品已在购物车中');
						return;
					}
				}

				// 先播抛物线动画，待小球砸入购物车并完成冲击反馈后，再发起接口请求
				await this.playCartParabola(event);
				try {
					await this.$store.dispatch('Cart/addCart', { goodList: [{ skuId, buyNum: 1 }] }).then(() => {
						// 接口成功后再轻微抖一下，二次强化“已加入购物车”的反馈
						this.shakeCartButton();
					});
					// TMessageBox.confirm('恭喜！商品已加入购物车。', '提示', { confirmButtonText: '去结算' })
					// 	.then(() => {
					// 		this.$router.push({ path: '/index/Cart' });
					// 	})
					// 	.catch(() => {});
				} catch (e) {
					TMessage.error('添加失败，请稍后重试');
				}
				return;

				this.addCart({ goodList: [{ skuId, buyNum: 1 }] })
					.then(() => {
						TMessage.success('已加入购物车');
					})
					.catch(() => {
						TMessage.error('添加失败，请稍后重试');
					});
			},

			// 加入购物车抛物线动画：从点击按钮飞入头部购物车，结束时带“砸入”冲击反馈
			playCartParabola(event) {
				return new Promise(resolve => {
					const btn = event && (event.currentTarget || event.target);
					if (!btn) {
						resolve();
						return;
					}
					const startRect = btn.getBoundingClientRect();
					const startX = startRect.left + startRect.width / 2;
					const startY = startRect.top + startRect.height / 2;

					// 终点：优先找 PageHeader 的购物车按钮，找不到回落到右上角
					const cartEl = document.querySelector('.btn-cart') || document.querySelector('.nav-btnbox .btn-cart') || document.querySelector('[data-cart-target]');
					let endX, endY;
					if (cartEl) {
						const r = cartEl.getBoundingClientRect();
						endX = r.left + r.width / 2;
						endY = r.top + r.height / 2;
					} else {
						endX = window.innerWidth - 80;
						endY = 40;
					}

					// 飞行的小球
					const ball = document.createElement('div');
					ball.innerHTML = '<i class="el-icon-shopping-cart-2"></i>';
					Object.assign(ball.style, {
						position: 'fixed',
						left: startX + 'px',
						top: startY + 'px',
						width: '34px',
						height: '34px',
						lineHeight: '34px',
						textAlign: 'center',
						borderRadius: '50%',
						background: 'linear-gradient(135deg, #f97316, #ef4444)',
						color: '#fff',
						fontSize: '18px',
						zIndex: 9999,
						pointerEvents: 'none',
						boxShadow: '0 6px 16px rgba(239,68,68,0.45)',
						transform: 'translate(-50%, -50%) scale(1)',
						willChange: 'left, top, transform, opacity'
					});
					document.body.appendChild(ball);

					// 加快速度：750ms -> 450ms
					const duration = 450;
					const startTime = performance.now();
					const dx = endX - startX;
					const dy = endY - startY;
					// 抛物线顶点高度（根据水平距离自适应）
					const peak = Math.min(Math.max(Math.abs(dx) * 0.35, 120), 260);

					const animate = now => {
						const t = Math.min((now - startTime) / duration, 1);
						// easeInCubic 让末端加速，更有“砸入”的冲击感
						const ease = t * t;
						const x = startX + dx * ease;
						const y = startY + dy * ease - 4 * peak * t * (1 - t);
						const scale = 1 - t * 0.4;
						ball.style.left = x + 'px';
						ball.style.top = y + 'px';
						ball.style.transform = 'translate(-50%, -50%) scale(' + scale + ')';
						if (t < 1) {
							requestAnimationFrame(animate);
						} else {
							// 【砸入冲击】小球瞬间扩张 + 透明消失，同时购物车按钮被“击中”压扁回弹
							ball.style.transition = 'transform 140ms ease-out, opacity 160ms ease-out';
							ball.style.transform = 'translate(-50%, -50%) scale(1.6)';
							ball.style.opacity = '0';
							setTimeout(() => ball.remove(), 200);

							if (cartEl && cartEl.animate) {
								cartEl.animate([{ transform: 'scale(1)' }, { transform: 'scale(0.82)', offset: 0.35 }, { transform: 'scale(1.18)', offset: 0.7 }, { transform: 'scale(1)' }], {
									duration: 260,
									easing: 'cubic-bezier(.2,.8,.2,1.2)'
								});
							}
							// 冲击前摆（~180ms）后 resolve，再执行 dispatch
							setTimeout(resolve, 180);
						}
					};
					requestAnimationFrame(animate);
				});
			},

			// 购物车按钮抖动反馈：在 addCart 接口成功后触发
			shakeCartButton() {
				const cartEl = document.querySelector('.btn-cart') || document.querySelector('.nav-btnbox .btn-cart') || document.querySelector('[data-cart-target]');
				if (!cartEl || !cartEl.animate) return;
				cartEl.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(0.92)' }, { transform: 'scale(1)' }], { duration: 420, easing: 'ease-out' });
			}
		}
	};
</script>

<style lang="less" scoped>
	.cart-page {
		min-height: calc(100vh - 120px);
		padding: 24px 0 120px;
		max-width: 82rem;
		margin: 0 auto;
	}

	// ===== Header =====
	.cart-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 24px;
		padding-bottom: 20px;
		border-bottom: 1px dashed #e2e8f0;
	}

	.cart-header-left {
		display: flex;
		align-items: center;
		gap: 14px;
	}

	.cart-header-icon {
		width: 44px;
		height: 44px;
		background: linear-gradient(135deg, #3b82f6, #6366f1);
		border-radius: 12px;
		display: flex;
		align-items: center;
		justify-content: center;

		i {
			font-size: 22px;
			color: #fff;
		}
	}

	.cart-header-text {
		h2 {
			margin: 0;
			font-size: 24px;
			font-weight: 700;
			color: #0f172a;
		}

		.cart-count-num {
			font-size: 18px;
			font-weight: 600;
			color: #666;
		}

		p {
			margin: 2px 0 0;
			font-size: 13px;
			color: #94a3b8;
		}
	}

	.cart-header-right {
		//width: 420px;
	}

	.cart-search-input {
		width: 400px;

		transition: width 0.35s cubic-bezier(0.4, 0, 0.2, 1);

		&.is-expanded,
		&:focus-within {
			width: 600px;
		}

		/deep/ .el-input__inner {
			height: 42px;
			line-height: 42px;
			border-radius: 12px;
			border: 1px solid #cbd5e1;
			padding-left: 40px;
			font-size: 15px;
			background: #fff;
			box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
			transition: all 0.2s;
			border-color: #155dfc;

			&:focus {
				box-shadow: 0 0 0 3px rgba(21, 93, 252, 0.1);
			}
		}
	}

	// ===== 搜索建议项 =====
	/deep/ .el-autocomplete-suggestion__list {
		.el-autocomplete-suggestion__item {
			padding: 4px 8px;
		}
	}

	/deep/ .el-autocomplete-suggestion li :hover {
		background: #fff !important;
	}

	.sku-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 12px;
		padding: 10px 12px;
		border-bottom: 1px solid #e2e8f0;
		background: #fff;
		transition: all 0.15s ease;

		&:hover {
			border-color: #bfdbfe;
			background: #f8faff;
		}

		.sku-left {
			flex: 1;
			min-width: 0;
			display: flex;
			flex-direction: column;
			gap: 4px;
		}

		.product-type-tag {
			flex-shrink: 0;
			border-radius: 4px;
			height: 22px;
			line-height: 20px;
			padding: 0 8px;
			font-weight: 600;
			width: 54px;
		}

		.sku-name {
			font-size: 15px;
			font-weight: 600;
			color: #0f172a;
			line-height: 1.4;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.spu-name {
			font-size: 12px;
			color: #64748b;
			line-height: 1.3;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			line-clamp: 2;
			-webkit-box-orient: vertical;
		}

		.sku-price {
			display: flex;
			align-items: baseline;
			gap: 8px;
			margin-top: 4px;
			flex-wrap: wrap;

			.now-price {
				font-size: 18px;
				font-weight: 800;
				color: #ef4444;
				line-height: 1;
				letter-spacing: -0.3px;
			}

			.before-price {
				font-size: 12px;
				color: #94a3b8;
				text-decoration: line-through;
			}

			.discount-tag {
				border: none;
				padding: 0 6px;
				height: 18px;
				line-height: 18px;
				font-weight: 600;
				border-radius: 4px;
			}

			.vip-price {
				font-size: 12px;
				color: #b45309;
				font-weight: 600;
				background: linear-gradient(135deg, #fef3c7, #fde68a);
				padding: 2px 8px;
				border-radius: 10px;
			}
		}

		.sku-add-btn {
			flex-shrink: 0;
			padding: 7px 14px;
			font-size: 12px;
			font-weight: 600;
			border-radius: 8px;
			background: linear-gradient(135deg, #2563eb, #1d4ed8);
			border: none;
			box-shadow: 0 2px 6px rgba(37, 99, 235, 0.25);
			transition: all 0.2s ease;

			&:hover {
				box-shadow: 0 4px 12px rgba(37, 99, 235, 0.4);
				transform: translateY(-1px);
			}

			&:active {
				transform: translateY(0);
			}
		}
	}

	.cart-toolbar {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 0 16px;
	}

	.cart-toolbar-left {
		display: flex;
		align-items: center;
		gap: 30px;
	}

	.cart-operator-filter {
		width: 250px;
	}

	.cart-toolbar-right {
		display: flex;
		align-items: center;
		gap: 8px;

		.el-button--text {
			color: #64748b;
			font-size: 13px;

			&:hover {
				color: #ef4444;
			}
		}
	}

	// ===== 商品列表 =====
	.cart-body {
		display: flex;
		flex-direction: column;
		gap: 10px;
	}

	.cart-item {
		display: flex;
		align-items: center;
		gap: 16px;
		padding: 20px 20px;
		background: #fff;
		border-radius: 14px;
		border: 1px solid #e2e8f0;
		transition: box-shadow 0.2s, border-color 0.2s;

		&:hover {
			border-color: #bfdbfe;
			box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
		}
	}

	.cart-item-check {
		flex-shrink: 0;
	}

	.cart-item-info {
		flex: 1;
		min-width: 0;
	}

	.cart-item-title {
		margin: 0;
		font-size: 15px;
		font-weight: 500;
		color: #0f172a;
		line-height: 1.5;
		display: flex;
		align-items: center;
		gap: 8px;
		flex-wrap: wrap;

		.el-tag {
			flex-shrink: 0;
		}
	}

	.cart-item-spu {
		font-size: 14px;
		// font-weight: 600;
		color: #1e293b;
		line-height: 1.6;
		word-break: break-all;
		margin-top: 6px;
	}

	.cart-item-standard {
		cursor: pointer;
		transition: color 0.2s;
		color: inherit;
		text-decoration: none;
		margin-right: 8px;

		&:hover {
			color: #155dfc;
		}

		&:active {
			color: #155dfc;
		}
	}

	.cart-item-type-badge {
		flex-shrink: 0;
		background: linear-gradient(135deg, #ef4444, #f97316);
		color: #ffffff;
		font-size: 11px;
		font-weight: 600;
		padding: 2px 8px;
		border-radius: 4px;
		display: inline-block;
		
	}

	.cart-item-price {
		flex-shrink: 0;
		text-align: right;
		display: flex;
		flex-direction: column;
		gap: 4px;
		align-items: flex-end;
		white-space: nowrap;
		margin-right: 18px;
	}

	.cart-now-price {
		font-size: 20px;
		font-weight: 800;
		color: #ef4444;
		letter-spacing: -0.3px;
	}

	.cart-before-price {
		font-size: 12px;
		color: #94a3b8;
		text-decoration: line-through;
		margin-left: 4px;
	}

	.cart-discount-tag {
		border: none;
		padding: 0 6px;
		height: 18px;
		line-height: 18px;
		font-weight: 600;
	}

	.cart-vip-price {
		//font-size: 12px;
		//color: #155dfc;
		//font-weight: 600;
		//background: #eff6ff;
		//padding: 2px 8px;
		//border-radius: 10px;
		//display: inline-block;
		//margin-top: 2px;

		font-size: 12px;
		color: #b45309;
		font-weight: 600;
		background: linear-gradient(135deg, #fef3c7, #fde68a);
		padding: 2px 8px;
		border-radius: 10px;
	}

	.cart-price-na {
		font-size: 14px;
		color: #94a3b8;
		font-weight: 500;
	}

	.cart-item-price-custom {
		justify-content: center;
	}

	// ===== 添加人 =====
	.cart-item-operator {
		//display: flex;
		//align-items: center;
		//gap: 8px;
		//flex-shrink: 0;
		//padding: 6px 12px;
		//background: linear-gradient(135deg, #eff6ff, #f0f9ff);
		//border: 1px solid #bfdbfe;
		//border-radius: 10px;
		//margin-right: 8px;

		flex-shrink: 0;
		text-align: center;

		.subtotal-label {
			display: block;
			font-size: 11px;
			color: #94a3b8;
		}

		i {
			font-size: 15px;
			color: #155dfc;
		}

		.operator-tags {
			display: flex;
			flex-wrap: wrap;
			gap: 6px;
		}

		.operator-tag {
			display: inline-block;
			font-size: 12px;
			font-weight: 600;
			color: #155dfc;
			padding: 4px 10px;
			border-radius: 14px;
			white-space: nowrap;
			letter-spacing: 0.2px;
			transition: all 0.2s;

			&:hover {
				//background: #bfdbfe;
				//transform: translateY(-1px);
			}
		}
	}

	.cart-item-qty {
		flex-shrink: 0;
		// margin-right: 18px;
	}

	.cart-item-subtotal {
		flex-shrink: 0;
		text-align: right;
		min-width: 108px;

		.subtotal-label {
			display: block;
			font-size: 11px;
			color: #94a3b8;
		}

		.subtotal-value {
			font-size: 18px;
			font-weight: 600;
			color: #0f172a;
		}
	}

	// ===== 是否已购 =====
	.cart-item-bought {
		flex-shrink: 0;
		text-align: center;
		min-width: 72px;

		.subtotal-label {
			display: block;
			font-size: 11px;
			color: #94a3b8;
		}

		.bought-yes {
			font-size: 18px;
			font-weight: 700;
			color: #10b981;
		}
	}

	.cart-item-actions {
		flex-shrink: 0;

		.el-link {
			font-size: 16px;
		}

		/deep/ .el-link--danger {
			color: #94a3b8;

			&:hover {
				color: #ef4444;
			}
		}
	}

	// ===== 底部结算 =====
	.cart-bottom {
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 10;
		background: #fff;
		border-top: 1px solid #e2e8f0;
		box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.06);
		padding: 16px calc((100% - 80rem) / 2 + 20px);
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.cart-bottom-left {
		display: flex;
		align-items: center;
		gap: 16px;
	}

	.cart-bottom-count {
		font-size: 14px;
		color: #475569;

		strong {
			color: #0f172a;
			font-size: 16px;
		}
	}

	.cart-bottom-right {
		display: flex;
		align-items: center;
		gap: 24px;
	}

	.cart-bottom-prices {
		display: flex;
		align-items: baseline;
		gap: 20px;
		font-size: 13px;

		span {
			white-space: nowrap;
		}
	}

	.cart-bottom-total {
		display: flex;
		align-items: baseline;
		gap: 6px;

		.total-label {
			color: #475569;
			font-size: 14px;
		}
		.total-value {
			font-size: 28px;
			font-weight: 800;
			color: #ef4444;
			letter-spacing: -0.5px;
		}
	}

	.cart-bottom-ori {
		display: flex;
		align-items: baseline;
		gap: 4px;

		.ori-label {
			color: #94a3b8;
		}
		.ori-value {
			font-size: 15px;
			color: #94a3b8;
			text-decoration: line-through;
		}
	}

	.cart-bottom-vip {
		font-size: 13px;
		color: #b45309;
		font-weight: 600;
		background: linear-gradient(135deg, #fef3c7, #fde68a);
		padding: 2px 8px;
		border-radius: 10px;

		display: flex;
		align-items: baseline;
		gap: 4px;

		//.vip-label { color: #94a3b8; }
		//.vip-value {
		//	font-size: 15px;
		//	font-weight: 600;
		//	color: #155dfc;
		//	background: #eff6ff;
		//	padding: 2px 10px;
		//	border-radius: 10px;
		//}
	}

	.cart-settle-btn {
		height: 46px;
		padding: 0 36px;
		font-size: 16px;
		font-weight: 600;
		color: #fff;
		border: none;
		border-radius: 23px;
		background: linear-gradient(135deg, #2563eb, #4f46e5);
		box-shadow: 0 4px 14px rgba(37, 99, 235, 0.3);
		cursor: pointer;
		transition: all 0.2s;
		white-space: nowrap;

		&:hover {
			transform: translateY(-1px);
			box-shadow: 0 6px 20px rgba(37, 99, 235, 0.4);
		}

		&:disabled {
			background: #cbd5e1;
			box-shadow: none;
			cursor: not-allowed;
			transform: none;
		}
	}

	// ===== 空状态 =====
	.cart-empty {
		text-align: center;
		padding: 100px 20px;

		.cart-empty-icon {
			width: 80px;
			height: 80px;
			margin: 0 auto 20px;
			background: #f1f5f9;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;

			i {
				font-size: 36px;
				color: #cbd5e1;
			}
		}

		h3 {
			font-size: 20px;
			font-weight: 600;
			color: #0f172a;
			margin: 0 0 8px;
		}

		p {
			font-size: 14px;
			color: #94a3b8;
			margin: 0 0 24px;
		}
	}

	// 复选框
	/deep/ .el-checkbox__inner {
		width: 16px;
		height: 16px;
		border-color: #cbd5e1;
		border-radius: 4px;
	}

	/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: #155dfc;
		border-color: #155dfc;
	}

	// 响应式
	@media screen and (max-width: 1023px) {
		.cart-page {
			padding: 16px 16px 120px;
			max-width: 100%;
		}

		.cart-header {
			flex-direction: column;
			align-items: flex-start;
			gap: 12px;
		}

		.cart-header-right {
			width: 100%;
		}

		.cart-item {
			flex-wrap: wrap;
			gap: 12px;
			padding: 16px;
		}

		.cart-item-subtotal {
			display: none;
		}

		.cart-bottom {
			padding: 12px 16px;
		}

		.cart-bottom-prices {
			gap: 12px;
		}

		.cart-bottom-total .total-value {
			font-size: 20px;
		}

		.cart-settle-btn {
			padding: 0 20px;
			font-size: 14px;
			height: 40px;
		}
	}

	@media screen and (max-width: 767px) {
		.cart-bottom-ori,
		.cart-bottom-vip {
			display: none;
		}

		.cart-item-price {
			min-width: auto;
		}

		.cart-bottom-right {
			gap: 12px;
		}
	}
</style>
<style>
	.my-autocomplete-popper .el-autocomplete-suggestion__wrap {
		max-height: 538px !important; /* 你可以设置你需要的最大高度 */
	}
</style>
